module.exports = __webpack_public_path__ + "img/1941-NewspaperMedia-cropped.3565ddba.jpg";